import Modal from "react-bootstrap/Modal";
import "./style.css";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import {
  apiEditItem,
  apiListBranch,
  apiListGodown,
  apiListItemCategory,
} from "../../../api/master";
import itemSchema from "../../../validations/itemSchema";
import {
  inputAlphanumSpe,
  inputfourDigitDeciaml,
  inputNumber,
  inputOnlyNumber,
} from "../../../utils";
import config from "../../../config";
import axios from "axios";
import addIcon from "../../../images/icons/add.png";
import deleteIcon from "../../../images/icons/delete.png";
import Swal from "sweetalert2";
import { FaExchangeAlt } from "react-icons/fa";
import ImageUploader from "./ImageUploader";

function ItemEdit(props) {
  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [shownew, setShownew] = useState(false);
  const [selectedcode, setSelectedCode] = useState("");
  const [item_godown_data, setItem_godown_data] = useState([
    { branch_id: "", godown_id: "" },
  ]);
  const [imagePreview, setImagePreview] = useState(null);
  const [branchError, setBranchError] = useState();
  const [defaultgodownError, setDefaultgodownError] = useState();
  const [imageFile, setImageFile] = useState(null); // New state
  const [currentImageUrl, setCurrentImageUrl] = useState(
    props.id?.img_url || null,
  ); // Existing image

  const ItemUnitList = props.itemUnitList;

  const [allBranch, setAllBranch] = useState([]);
  const [allGodown, setAllGodown] = useState([]);
  const [allItemCat, setAllItemCat] = useState([]);

  useEffect(() => {
    setAllBranch(props?.allBranch);
    setAllGodown(props?.allGodown);
    setAllItemCat(props?.allItemCat);
  });

  const branchListMap = allBranch?.flatMap((el) => {
    return {
      value: el?.branch_id,
      label: el?.branch_name,
    };
  });
  const godownListMap = allGodown?.flatMap((el) => {
    return {
      value: el?.godown_id,
      label: el.godown_name,
    };
  });
  const itemCatListMap = allItemCat?.flatMap((el) => {
    return {
      value: el?.item_cat_id,
      label: el?.item_cat_name,
    };
  });
  useEffect(() => {
    setCurrentImageUrl(props?.id?.img_url);
    if (props.id?.item_godown_data.length > 0) {
      const branchGodownData = props.id?.item_godown_data
        ? props.id.item_godown_data.map((data) => ({
            branch_id: data.branch_id,
            godown_id: data.godown_id,
          }))
        : [];

      setItem_godown_data(branchGodownData);
    }
  }, []);

  const itemFormik = useFormik({
    initialValues: {
      item_id: props?.id?.item_id,
      item_name: props?.id.item_name,
      video_url: props?.id.video_url,
      item_cat_id: props?.id.item_cat_id,
      item_cat_name: props?.id.item_cat_name,
      alt_price: props?.id.alt_price,
      item_price: props?.id.item_price,
      item_desc: props?.id.item_desc,
      item_unit: props?.id.item_unit,
      alt_unit: props?.id.alt_unit,
      alt_conv: props?.id.alt_conv,
      item_godown_data: props?.id.item_godown_data,
      alt_min_price: props?.id.alt_min_price,
      item_min_price: props?.id.item_min_price,
      barcode: props?.id.barcode || "",
      SKU: props?.id.SKU || "",
      category_code: props?.id?.category_code ?? "",
      field_1: props?.id.field_1 || "",
      field_2: props?.id.field_2 || "",
      field_3: props?.id.field_3 || "",
    },

    validationSchema: itemSchema.validateItemEdit(),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      const formData = new FormData();
      // values = {
      //   item_id: values?.item_id,
      //   item_name: values?.item_name,
      //   video_url: values?.video_url,
      //   item_cat_id: values?.item_cat_id,
      //   item_cat_name: values?.item_cat_name,
      //   item_desc: values?.item_desc,
      //   item_price: values?.item_price,
      //   alt_price: values?.alt_price,
      //   item_unit: values?.item_unit,
      //   alt_unit: values.alt_unit,
      //   alt_conv: Number(values.alt_conv),
      //   item_godown_data: values.item_godown_data,
      //   alt_min_price: values?.alt_min_price,
      //   item_min_price: values?.item_min_price,
      // };
      // let godown_data = item_godown_data.filter((s) => s.godown_id != "");
      formData.append("item_id", values.item_id);
      formData.append("item_name", values.item_name);
      formData.append("video_url", values.video_url || "");
      formData.append("item_cat_id", Number(values.item_cat_id));
      formData.append("item_cat_name", values.item_cat_name || "");
      formData.append("item_desc", values.item_desc || "");
      formData.append("item_price", Number(values.item_price));
      formData.append("alt_price", Number(values.alt_price));
      formData.append("item_unit", values.item_unit);
      formData.append("alt_unit", values.alt_unit || "");
      formData.append("alt_conv", Number(values.alt_conv));
      formData.append("item_min_price", Number(values.item_min_price || 0));
      formData.append("alt_min_price", Number(values.alt_min_price || 0));
      formData.append("barcode", values.barcode);
      formData.append("SKU", values.SKU);
      formData.append("category_code", values.category_code || "");
      formData.append("field_1", values.field_1);
      formData.append("field_2", values.field_2);
      formData.append("field_3", values.field_3);

      // **NEW IMAGE FILE**
      if (imageFile) {
        formData.append("img_url", imageFile);
      }

      // Godown data
      // let godown_data = item_godown_data.filter((s) => s.godown_id != "");
      // if (godown_data.length > 0) {
      //   formData.append("item_godown_data", JSON.stringify(godown_data));
      // }
      let godown_data = item_godown_data.filter((s) => s.godown_id != "");

      if (godown_data.length > 0) {
        godown_data.forEach((item, index) => {
          Object.entries(item).forEach(([key, value]) => {
            formData.append(`item_godown_data[${index}][${key}]`, value);
          });
        });
      }

      setBranchError("");
      setDefaultgodownError("");

      // if (item_godown_data.length === 1) {
      //   if (item_godown_data[item_godown_data.length - 1].branch_id == "") {
      //     setBranchError("Branch Name is required");
      //     setIsSubmit(false);

      //     return;
      //   }
      //   if (item_godown_data[item_godown_data.length - 1].godown_id == "") {
      //     setDefaultgodownError("Gowdown Name is required");
      //     setIsSubmit(false);

      //     return;
      //   }
      // }
      // if (godown_data.length > 0) {
      //   values = { ...values, item_godown_data: godown_data };
      // }
      setIsSubmit(true);
      if (
        values.alt_unit &&
        values.item_unit &&
        values.alt_unit !== values.item_unit &&
        Number(values.alt_conv) === 1
      ) {
        const alertResult = await Swal.fire({
          title: "Are you sure?",
          html:
            "1 of <b>" +
            values.item_unit +
            "</b> is equal to 1 of <b>" +
            values.alt_unit +
            "</b>. Please confirm.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, save",
          cancelButtonText: "No, cancel",
          reverseButtons: true,
        });

        if (!alertResult.isConfirmed) {
          setIsSubmit(false);
          return; // block submission
        }
      }
      await apiEditItem(formData)
        .then((data) => {
          setSuccess(data.data.message);
          setError("");
          props.list();
        })
        .catch((err) => {
          setError(err.response.data.data.message);
          setSuccess("");
        })
        .finally((result) => {
          setIsSubmit(false);
          setTimeout(() => {
            setSuccess("");
            setError("");
          }, 5000);
        });
    },
  });

  useEffect(function () {}, [success, error]);
  const [unit, setUnit] = useState(false);

  useEffect(() => {
    if (itemFormik.values.item_unit == itemFormik.values.alt_unit) {
      setUnit(true);
      itemFormik.setFieldValue("alt_conv", 1);
      itemFormik.setFieldValue("alt_price", itemFormik.values.item_price);
      itemFormik.setFieldValue(
        "alt_min_price",
        itemFormik.values.item_min_price,
      );
    } else {
      setUnit(false);
    }
  }, [itemFormik.values]);
  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "20rem", height: "4px" }} id="modalhead">
          Edit Item
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="buyerAdd">
        <form
          className="row gx-5 gy-2"
          onSubmit={itemFormik.handleSubmit}
          autoComplete="off"
        >
          <div className="col-md-6">
            <label htmlFor="item_name">
              Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="item_name"
              maxLength={100}
              onKeyDown={inputAlphanumSpe}
              {...itemFormik.getFieldProps("item_name")}
            />
            {itemFormik.errors.item_name && shownew !== true ? (
              <div className="text-danger small">
                {itemFormik.errors.item_name}
              </div>
            ) : null}
          </div>

          <div className="col-md-6">
            <label htmlFor="item_cat_id">Category</label>
            <select
              className="form-control"
              name="item_cat_id"
              value={itemFormik.values.item_cat_id}
              onChange={(e) => {
                itemFormik.setFieldValue("item_cat_id", e.target.value);
              }}
            >
              <option value="">Select</option>
              {itemCatListMap.map((option) => (
                <option value={option.value}>{option.label}</option>
              ))}
            </select>
            {itemFormik.errors.item_cat_id && shownew !== true ? (
              <div className="text-danger small">
                {itemFormik.errors.item_cat_id}
              </div>
            ) : null}
          </div>

          <div className="col-md-12">
            <label htmlFor="item_desc"> Description</label>
            <textarea
              type="text"
              className="form-control"
              id="item_desc"
              onKeyDown={inputAlphanumSpe}
              maxLength={2000}
              {...itemFormik.getFieldProps("item_desc")}
            />
            {itemFormik.errors.item_desc && shownew !== true ? (
              <div className="text-danger small">
                {itemFormik.errors.item_desc}
              </div>
            ) : null}
          </div>

          <div className="col-md-6">
            <label htmlFor="item_unit">
              Base Unit <span className="text-danger">*</span>
            </label>
            <select
              type="text"
              className="form-select"
              id="item_unit"
              {...itemFormik.getFieldProps("item_unit")}
            >
              <option value="" hidden>
                Select...
              </option>
              {ItemUnitList.map((list) => {
                return <option value={list.value}>{list.label}</option>;
              })}
            </select>
            {itemFormik.errors.item_unit && shownew !== true ? (
              <div className="text-danger small">
                {itemFormik.errors.item_unit}
              </div>
            ) : null}
          </div>

          <div className="col-md-6">
            <label htmlFor="alt_unit">
              Alternate Unit <span className="text-danger">*</span>
            </label>
            <select
              type="text"
              className="form-select"
              id="alt_unit"
              {...itemFormik.getFieldProps("alt_unit")}
            >
              <option value="" hidden>
                Select...
              </option>
              {ItemUnitList.map((list) => {
                return <option value={list.value}>{list.label}</option>;
              })}
            </select>
            {itemFormik.errors.alt_unit && shownew !== true ? (
              <div className="text-danger small">
                {itemFormik.errors.alt_unit}
              </div>
            ) : null}
          </div>
          <div className="col-md-5">
            <label htmlFor="item_price">Base Conversion</label>
            <input
              autoComplete="off"
              type="text"
              className="form-control"
              id="item_price"
              value="1"
              disabled
            />
          </div>
          <div className="col-md-2 d-flex align-items-center justify-content-center">
            <FaExchangeAlt className="mt-4" />
          </div>
          <div className="col-md-5">
            <label htmlFor="alt_conv">
              Alternate Conversion <span className="text-danger">*</span>
            </label>
            <input
              autoComplete="off"
              type="text"
              onKeyDown={inputfourDigitDeciaml}
              // maxLength={9}
              className="form-control"
              id="alt_conv"
              {...itemFormik.getFieldProps("alt_conv")}
              disabled={unit}
            />
            {itemFormik.errors.alt_conv && shownew != true ? (
              <div className="text-danger small">
                {itemFormik.errors.alt_conv}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="item_min_price">Min Price</label>
            <input
              autoComplete="off"
              type="text"
              onKeyDown={inputNumber}
              maxLength={9}
              className="form-control"
              id="item_min_price"
              {...itemFormik.getFieldProps("item_min_price")}
            />
            {itemFormik.errors.item_min_price && shownew != true ? (
              <div className="text-danger small">
                {itemFormik.errors.item_min_price}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="item_price">
              Max Price <span className="text-danger">*</span>
            </label>
            <input
              autoComplete="off"
              type="text"
              onKeyDown={inputNumber}
              maxLength={9}
              className="form-control"
              id="item_price"
              {...itemFormik.getFieldProps("item_price")}
            />
            {itemFormik.errors.item_price && shownew !== true ? (
              <div className="text-danger small">
                {itemFormik.errors.item_price}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="alt_min_price">Min Alternate Price</label>
            <input
              autoComplete="off"
              type="text"
              onKeyDown={inputNumber}
              maxLength={9}
              className="form-control"
              id="alt_min_price"
              disabled={unit}
              {...itemFormik.getFieldProps("alt_min_price")}
            />
            {itemFormik.errors.alt_min_price && shownew != true ? (
              <div className="text-danger small">
                {itemFormik.errors.alt_min_price}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="alt_price">
              Max Alternate Price <span className="text-danger">*</span>
            </label>
            <input
              autoComplete="off"
              type="text"
              onKeyDown={inputNumber}
              maxLength={9}
              className="form-control"
              id="alt_price"
              disabled={unit}
              {...itemFormik.getFieldProps("alt_price")}
            />
            {itemFormik.errors.alt_price && shownew != true ? (
              <div className="text-danger small">
                {itemFormik.errors.alt_price}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="barcode">Barcode</label>
            <input
              maxLength={20}
              type="text"
              className="form-control"
              id="barcode"
              onKeyDown={inputAlphanumSpe}
              {...itemFormik.getFieldProps("barcode")}
            />
            {itemFormik.errors.barcode && shownew != true ? (
              <div className="text-danger small">
                {itemFormik.errors.barcode}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="SKU">SKU</label>
            <input
              maxLength={20}
              type="text"
              className="form-control"
              id="SKU"
              onKeyDown={inputAlphanumSpe}
              {...itemFormik.getFieldProps("SKU")}
            />
            {itemFormik.errors.SKU && shownew != true ? (
              <div className="text-danger small">{itemFormik.errors.SKU}</div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="category_code">URA Category Code</label>
            <input
              maxLength={8}
              type="text"
              className="form-control"
              id="category_code"
              placeholder="Enter 8-digit URA Category Code"
              onKeyDown={(e) => {
                if (e.ctrlKey || e.metaKey) return;
                inputOnlyNumber(e);
              }}
              onPaste={(e) => {
                e.preventDefault();
                const pasteData = e.clipboardData
                  ? e.clipboardData.getData("text")
                  : "";
                const pastedDigits = pasteData.replace(/\D/g, "");
                const input = e.target;
                const start = input.selectionStart ?? 0;
                const end = input.selectionEnd ?? input.value.length;
                const currentValue = itemFormik.values.category_code || "";
                const newValue = (
                  currentValue.slice(0, start) +
                  pastedDigits +
                  currentValue.slice(end)
                ).slice(0, 8);
                itemFormik.setFieldValue("category_code", newValue);
              }}
              name="category_code"
              value={itemFormik.values.category_code}
              onChange={(e) => {
                const val = e.target.value.replace(/\D/g, "").slice(0, 8);
                itemFormik.setFieldValue("category_code", val);
              }}
              onBlur={itemFormik.handleBlur}
            />
            {itemFormik.errors.category_code && shownew != true ? (
              <div className="text-danger small">
                {itemFormik.errors.category_code}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="field_1">Field 1</label>
            <input
              maxLength={30}
              type="text"
              className="form-control"
              id="field_1"
              onKeyDown={inputAlphanumSpe}
              {...itemFormik.getFieldProps("field_1")}
            />
            {itemFormik.errors.field_1 && shownew != true ? (
              <div className="text-danger small">
                {itemFormik.errors.field_1}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="field_2">Field 2</label>
            <input
              maxLength={30}
              type="text"
              className="form-control"
              id="field_2"
              onKeyDown={inputAlphanumSpe}
              {...itemFormik.getFieldProps("field_2")}
            />
            {itemFormik.errors.field_2 && shownew != true ? (
              <div className="text-danger small">
                {itemFormik.errors.field_2}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="field_3">Field 3</label>
            <input
              maxLength={30}
              type="text"
              className="form-control"
              id="field_3"
              onKeyDown={inputAlphanumSpe}
              {...itemFormik.getFieldProps("field_3")}
            />
            {itemFormik.errors.field_3 && shownew != true ? (
              <div className="text-danger small">
                {itemFormik.errors.field_3}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="video_url">Video URL</label>
            <input
              maxLength={100}
              type="text"
              className="form-control"
              id="video_url"
              // onKeyDown={inputAlphanumSpe}
              {...itemFormik.getFieldProps("video_url")}
            />
            {itemFormik.errors.video_url && shownew !== true ? (
              <div className="text-danger small">
                {itemFormik.errors.video_url}
              </div>
            ) : null}
          </div>
          <div className="col-md-12 mt-4">
            <ImageUploader
              label="Product Image"
              imagePreview={imagePreview}
              setImagePreview={setImagePreview}
              maxSizeMB={5}
              onImageChange={(file) => setImageFile(file)}
              disabled={isSubmit}
              initialImageUrl={currentImageUrl}
            />
          </div>

          <div className="col-12 mt-4">
            <hr style={{ marginBottom: "5px" }} />

            <p
              style={{
                fontSize: "13px",
                fontWeight: "bold",
                textTransform: "uppercase",
              }}
            >
              Default Godown
            </p>
            {props.id?.item_godown_data &&
              props.id?.item_godown_data?.length > 0 && (
                <table className="table table-sm table-borderless table-hover w-100">
                  <thead>
                    <tr>
                      <th style={{ fontSize: "12px" }}>
                        Branch <span className="text-danger">*</span>
                      </th>
                      <th style={{ fontSize: "12px" }}>
                        Godown <span className="text-danger">*</span>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {item_godown_data?.map((v, i) => (
                      <tr key={i}>
                        <td className="w-50">
                          <select
                            value={
                              item_godown_data[i]?.branch_id || v.branch_id
                            }
                            className="form-select"
                            onChange={(e) => {
                              setItem_godown_data((prevState) =>
                                prevState.map((p, j) =>
                                  i == j
                                    ? {
                                        ...p,
                                        branch_id: e.target.value,
                                      }
                                    : p,
                                ),
                              );
                            }}
                          >
                            <option value="" hidden>
                              Select...
                            </option>
                            {branchListMap?.map((list) => {
                              return (
                                <option
                                  value={list?.value}
                                  // hidden={item_godown_data
                                  //   .map((s) => Number(s.branch_id))
                                  //   .includes(Number(list?.value))}
                                >
                                  {list?.label}
                                </option>
                              );
                            })}
                          </select>
                          <span
                            style={{
                              color: "#dc3545",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >
                            {branchError}
                          </span>
                        </td>
                        <td>
                          <select
                            className="form-select"
                            value={
                              item_godown_data[i]?.godown_id || v.godown_id
                            }
                            onChange={(e) => {
                              setItem_godown_data((prevState) =>
                                prevState.map((p, j) =>
                                  i == j
                                    ? {
                                        ...p,
                                        godown_id: e.target.value,
                                      }
                                    : p,
                                ),
                              );
                            }}
                          >
                            <option value="" hidden>
                              Select...
                            </option>
                            {allGodown

                              // .filter((f) =>
                              //   f.branch_id?.some(id => item_godown_data[i]?.branch_id.includes(id))
                              // )
                              .filter((f) =>
                                f.branch_id?.includes(
                                  Number(item_godown_data[i]?.branch_id),
                                ),
                              )
                              ?.map((list) => {
                                return (
                                  <option
                                    value={list?.godown_id}
                                    hidden={item_godown_data
                                      ?.map((s) => Number(s.godown_id))
                                      .includes(Number(list?.godown_id))}
                                  >
                                    {list?.godown_name}
                                  </option>
                                );
                              })}
                          </select>
                          <span
                            style={{
                              color: "#dc3545",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >
                            {defaultgodownError}
                          </span>
                        </td>
                        <td style={{ width: "70px" }}>
                          {item_godown_data.length - 1 == i && (
                            <img
                              src={addIcon}
                              className="img-fluid m-1"
                              alt=""
                              onClick={() => {
                                if (
                                  item_godown_data[item_godown_data.length - 1]
                                    .godown_id == "" ||
                                  item_godown_data[item_godown_data.length - 1]
                                    .branch_id == ""
                                ) {
                                  Swal.fire({
                                    html: "Please fill proper data.",
                                  });
                                } else {
                                  setItem_godown_data((prevState) => [
                                    ...prevState,
                                    {
                                      branch_id: "",
                                      godown_id: "",
                                    },
                                  ]);
                                  setBranchError("");
                                  setDefaultgodownError("");
                                }
                              }}
                              role="button"
                            />
                          )}
                          {item_godown_data.length > 1 && (
                            <img
                              src={deleteIcon}
                              className="img-fluid m-1"
                              alt=""
                              onClick={() =>
                                setItem_godown_data([
                                  ...item_godown_data.filter((s, j) => i != j),
                                ])
                              }
                              role="button"
                            />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}

            {props.id?.item_godown_data &&
              props.id?.item_godown_data?.length === 0 && (
                <table className="table table-sm table-borderless table-hover w-100">
                  <thead>
                    <tr>
                      <th style={{ fontSize: "12px" }}>Branch</th>
                      <th style={{ fontSize: "12px" }}>Godown</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {item_godown_data &&
                      item_godown_data?.map((v, i) => (
                        <tr key={i}>
                          <td className="w-50">
                            <select
                              value={item_godown_data[i]?.branch_id || ""}
                              className="form-select"
                              onChange={(e) => {
                                setItem_godown_data((prevState) =>
                                  prevState.map((p, j) =>
                                    i == j
                                      ? {
                                          ...p,
                                          branch_id: e.target.value,
                                        }
                                      : p,
                                  ),
                                );
                              }}
                            >
                              <option value="" hidden>
                                Select...
                              </option>
                              {branchListMap?.map((list) => {
                                return (
                                  <option
                                    value={list?.value}
                                    hidden={item_godown_data
                                      .map((s) => Number(s.branch_id))
                                      .includes(Number(list?.value))}
                                  >
                                    {list?.label}
                                  </option>
                                );
                              })}
                            </select>
                            <span
                              style={{
                                color: "#dc3545",
                                fontSize: "14px",
                                fontWeight: "400",
                              }}
                            >
                              {branchError}
                            </span>
                          </td>
                          <td>
                            <select
                              value={item_godown_data[i]?.godown_id || ""}
                              className="form-select"
                              onChange={(e) => {
                                setItem_godown_data((prevState) =>
                                  prevState.map((p, j) =>
                                    i == j
                                      ? {
                                          ...p,
                                          godown_id: e.target.value,
                                        }
                                      : p,
                                  ),
                                );
                              }}
                            >
                              <option value="" hidden>
                                Select...
                              </option>
                              {allGodown

                                .filter((f) =>
                                  f.branch_id?.some((id) =>
                                    item_godown_data[i]?.branch_id.includes(id),
                                  ),
                                )
                                ?.map((list) => {
                                  return (
                                    <option value={list?.godown_id}>
                                      {list?.godown_name}
                                    </option>
                                  );
                                })}
                            </select>
                            <span
                              style={{
                                color: "#dc3545",
                                fontSize: "14px",
                                fontWeight: "400",
                              }}
                            >
                              {defaultgodownError}
                            </span>
                          </td>
                          <td style={{ width: "70px" }}>
                            {item_godown_data.length - 1 == i && (
                              <img
                                src={addIcon}
                                className="img-fluid m-1"
                                alt=""
                                onClick={() => {
                                  if (
                                    item_godown_data[
                                      item_godown_data.length - 1
                                    ].godown_id == "" ||
                                    item_godown_data[
                                      item_godown_data.length - 1
                                    ].branch_id == ""
                                  ) {
                                    Swal.fire({
                                      html: "Please fill proper data.",
                                    });
                                  } else {
                                    setItem_godown_data((prevState) => [
                                      ...prevState,
                                      {
                                        branch_id: "",
                                        godown_id: "",
                                      },
                                    ]);
                                    setBranchError("");
                                    setDefaultgodownError("");
                                  }
                                }}
                                role="button"
                              />
                            )}
                            {item_godown_data.length > 1 && (
                              <img
                                src={deleteIcon}
                                className="img-fluid m-1"
                                alt=""
                                onClick={() =>
                                  setItem_godown_data([
                                    ...item_godown_data.filter(
                                      (s, j) => i != j,
                                    ),
                                  ])
                                }
                                role="button"
                              />
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              )}
            {(error || success) && (
              <div
                className={`alert alert-${
                  error ? "danger" : "success"
                } py-2 small`}
                role="alert"
              >
                {error || success || ""}
              </div>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
                float: "right",
              }}
            >
              <button
                className="branchModalCancel"
                onClick={props.hide}
                type="button"
                style={{
                  height: "33px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  float: "right",
                }}
              >
                Cancel
              </button>
              {shownew ? (
                <button
                  id="createNew"
                  onClick={() => {
                    setSelectedCode(null);
                    itemFormik.resetForm();
                    setShownew(false);
                    setSuccess("");
                  }}
                  style={{
                    height: "33px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    float: "right",
                  }}
                >
                  Add New
                </button>
              ) : (
                <button
                  type="submit"
                  disabled={isSubmit}
                  style={{
                    height: "33px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    float: "right",
                  }}
                >
                  {isSubmit && (
                    <span className="spinner-border spinner-border-sm me-2"></span>
                  )}
                  Save
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default ItemEdit;
